import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useParams, useNavigate } from 'react-router-dom';
import AddSorteoComponents from "../../../components/AddSorteoComponents";
import dayjs from 'dayjs';
import { useSelector } from "react-redux";
import { getDetalleSorteo, postAddSorteo, postUpdateSorteo } from "../../../api/ApiService";


function AddSorteoPage() {
    const [cargando, setCargando] = useState(false);
    const [titulo, setTitulo] = useState('');
    const [linkUrl, setLinkUrl] = useState('');
    const [imagen, setImagen] = useState('');
    const [imagenFormData, setImagenFormData] = useState('');
    const [imagenDetalle, setImagenDetalle] = useState('');
    const [imagenDetalleFormData, setImagenDetalleFormData] = useState('');
    const [activoStatus, setActivoStatus] = useState(false);
    const [sorteoEspecial, setSorteoEspecial] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [descripcion, setDescripcion] = useState('');
    const [ratioGuaranies, setRatioGuaranies] = useState('');
    const [ratioDolares, setRatioDolares] = useState('');
    const [ratioGuaraniesCheck, setRatioGuaraniesCheck] = useState('');
    const [ratioDolaresCheck, setRatioDolaresCheck] = useState('');
    //fecha inicio sorteo
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    //fecha hasta sorteo
    const [fechaHasta, setFechaHasta] = useState(null);
    const [fechaHastaBackend, setFechaHastaBackend] = useState('');

    //fecha inicio publicacion
    const [fechaInicioPublicacion, setFechaInicioPublicacion] = useState(null);
    const [fechaInicioPublicacionBackend, setFechaInicioPublicacionBackend] = useState('');
    //fecha hasta sorteo
    const [fechaHastaPublicacion, setFechaHastaPublicacion] = useState(null);
    const [fechaHastaPublicacionBackend, setFechaHastaPublicacionBackend] = useState('');


    //fecha vigencia facturas
    const [fechaInicioVigenciaFacturas, setFechaInicioVigenciaFacturas] = useState(null);
    const [fechaInicioVigenciaFacturasBackend, setFechaInicioVigenciaFacturasBackend] = useState('');

    const [fechaHastaVigenciaFacturas, setFechaHastaVigenciaFacturas] = useState(null);
    const [fechaHastaVigenciaFacturasBackend, setFechaHastaVigenciaFacturasBackend] = useState('');


    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("info data", id);

    const params = useParams();

    const { id } = params;
    console.log("id", id);

    const navigate = useNavigate();


    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleSorteo();
            }
        } else {
            setTimeout(() => {
                setCargando(true);
            }, 1000);
        }
    }, [id, stateToken]);

    //==========================================================funcion para enviar encuesta a la api
    const handleDetalleSorteo = () => {
        getDetalleSorteo(id, stateToken?.access_token)
            .then(response => {
                console.log("getDetalleEvento", response);
                setCargando(true);
                setTitulo(response?.data?.titulo);
                setDescripcion(response?.data?.descripcion);
                setImagen(response?.data?.imagen);
                setImagenDetalle(response?.data?.img_detalle);

                setLinkUrl(response?.data?.link);

                setRatioGuaranies(response?.data?.ratio);
                setRatioGuaraniesCheck(response?.data?.ratio_maximo_guaranies);

                setRatioDolares(response?.data?.ratio_dolares);
                setRatioDolaresCheck(response?.data?.ratio_maximo_dolares);

                setFechaInicio(dayjs(response?.data?.vigencia_promocion_desde));
                setFechaInicioBackend(response?.data?.vigencia_promocion_desde);

                setFechaHasta(dayjs(response?.data?.vigencia_promocion_hasta));
                setFechaHastaBackend(response?.data?.vigencia_promocion_hasta);

                setFechaInicioPublicacion(dayjs(response?.data?.vigencia_publicacion_desde));
                setFechaInicioPublicacionBackend(response?.data?.vigencia_publicacion_desde);

                setFechaHastaPublicacion(dayjs(response?.data?.vigencia_publicacion_hasta));
                setFechaHastaPublicacionBackend(response?.data?.vigencia_publicacion_hasta);

                setActivoStatus(response?.data?.es_prueba === "1" ? true : false);
                setSorteoEspecial(response?.data?.con_sorteo_especial === "1" ? true : false);

                if (response?.data?.con_sorteo_especial === "1") {
                    setSorteoEspecial(true);

                    setFechaInicioVigenciaFacturas(dayjs(response?.data?.facturas_desde_sorteo_especial));
                    setFechaInicioVigenciaFacturasBackend(response?.data?.facturas_desde_sorteo_especial);

                    setFechaHastaVigenciaFacturas(dayjs(response?.data?.facturas_hasta_sorteo_especial));
                    setFechaHastaVigenciaFacturasBackend(response?.data?.facturas_hasta_sorteo_especial);
                }




            })
            .catch(error => {
                console.log("error-getDetalleEvento", error);
                setLoadingGuardar(false);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }



    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //=========================================================funcion para guardar
    const handleGuardar = () => {
        let formData = new FormData();
        formData.append('titulo', titulo);
        formData.append('descripcion', descripcion);
        formData.append('link', linkUrl);
        formData.append('ratio', ratioGuaranies);
        formData.append('ratio_dolares', ratioDolares);
        formData.append('ratio_guaranies_check', ratioGuaraniesCheck);
        formData.append('ratio_dolares_check', ratioDolaresCheck);
        formData.append('vigencia_desde', fechaInicioBackend);
        formData.append('vigencia_hasta', fechaHastaBackend);
        formData.append('publicacion_desde', fechaInicioPublicacionBackend);
        formData.append('publicacion_hasta', fechaHastaPublicacionBackend);
        formData.append('es_prueba', activoStatus ? "1" : "0");
        formData.append('sorteo_especial', sorteoEspecial ? "1" : "0");
        // formData.append('ingrese_facturas_desde', fechaInicioVigenciaFacturasBackend);
        formData.append('ingrese_facturas_desde', sorteoEspecial ? fechaInicioVigenciaFacturasBackend : '');
        formData.append('ingrese_facturas_hasta', sorteoEspecial ? fechaHastaVigenciaFacturasBackend : '');
        formData.append('imagen', imagenFormData);
        formData.append('imgDetalle', imagenDetalleFormData);

        console.log("formData", formData);



        //validar campos que no esten vacios
        if (titulo.trim() === '') {

            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo titulo es requerido');

        } else if (linkUrl.trim() === '') {

            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo link es requerido');

        } else if (descripcion.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo descripcion es requerido');
        } else if (ratioGuaranies.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo ratio guaranies es requerido');

        } else if (ratioDolares.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo ratio dolares es requerido');

        } else if (ratioGuaraniesCheck.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo ratio guaranies check es requerido');

        } else if (ratioDolaresCheck.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo ratio dolares check es requerido');

        } else if (fechaInicioBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha inicio sorteo es requerido');

        } else if (dayjs(fechaInicioBackend).isAfter(dayjs(fechaHastaBackend))) {
            // Validar que la fecha de inicio no sea mayor que la fecha de fin
            setOpen(true);
            setSeverity('warning');
            setMensaje('La fecha de Hasta no puede ser menor a la fecha desde, en la vigencia del sorteo');
            return;

        } else if (fechaHastaBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha hasta sorteo es requerido');

        } else if (fechaInicioPublicacionBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha inicio publicacion es requerido');

        } else if (fechaHastaPublicacionBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha hasta publicacion es requerido');

        } else if (dayjs(fechaInicioPublicacionBackend).isAfter(dayjs(fechaHastaPublicacionBackend))) {
            // Validar que la fecha de inicio no sea mayor que la fecha de fin
            setOpen(true);
            setSeverity('warning');
            setMensaje('La fecha de Hasta no puede ser menor a la fecha desde, en la vigencia de publicacion');
            return;

        } else if (imagenFormData === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo imagen es requerido');

        } else if (imagenDetalleFormData === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo imagen detalle es requerido');
        } else {
            if (sorteoEspecial) {
                if (fechaInicioVigenciaFacturasBackend === '') {
                    setOpen(true);
                    setSeverity('warning');
                    setMensaje('El campo fecha inicio vigencia facturas es requerido');

                } else if (fechaHastaVigenciaFacturasBackend === '') {
                    setOpen(true);
                    setSeverity('warning');
                    setMensaje('El campo fecha hasta vigencia facturas es requerido');

                } else if (dayjs(fechaInicioVigenciaFacturasBackend).isAfter(dayjs(fechaHastaVigenciaFacturasBackend))) {
                    // Validar que la fecha de inicio no sea mayor que la fecha de fin
                    setOpen(true);
                    setSeverity('warning');
                    setMensaje('La fecha de Hasta no puede ser menor a la fecha desde, en la vigencia de facturas');
                    return;

                } else {
                    setLoadingGuardar(true);

                    handleAddSorteoApi(formData);
                }

            } else {

                setLoadingGuardar(true);

                handleAddSorteoApi(formData);
            }
        }
    };



    //=========================================================api de crear sorteo
    const handleAddSorteoApi = (body) => {

        postAddSorteo(body, stateToken?.access_token)
            .then((response) => {
                console.log("response-postAddSorteo", response);
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');

                    setTimeout(() => {
                        navigate('/app/admin/sorteos');
                    }, 1500);

                }, 1000);


            })
            .catch((error) => {
                console.log("error-postAddSorteo", error);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar el sorteo');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };





    //=========================================================funcion para editar sorteo
    const handleUpdateSorteo = () => {
        let formData = new FormData();
        formData.append('titulo', titulo);
        formData.append('descripcion', descripcion);
        formData.append('link', linkUrl);
        formData.append('ratio', ratioGuaranies);
        formData.append('ratio_dolares', ratioDolares);
        formData.append('ratio_guaranies_check', ratioGuaraniesCheck);
        formData.append('ratio_dolares_check', ratioDolaresCheck);
        formData.append('vigencia_desde', fechaInicioBackend);
        formData.append('vigencia_hasta', fechaHastaBackend);
        formData.append('publicacion_desde', fechaInicioPublicacionBackend);
        formData.append('publicacion_hasta', fechaHastaPublicacionBackend);
        formData.append('es_prueba', activoStatus ? "1" : "0");
        formData.append('sorteo_especial', sorteoEspecial ? "1" : "0");
        formData.append('ingrese_facturas_desde', sorteoEspecial ? fechaInicioVigenciaFacturasBackend : '');
        formData.append('ingrese_facturas_hasta', sorteoEspecial ? fechaHastaVigenciaFacturasBackend : '');
        formData.append('imagen', imagenFormData);
        formData.append('imgDetalle', imagenDetalleFormData);

        console.log("formData", formData);


        //validar campos que no esten vacios
        if (titulo.trim() === '') {

            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo titulo es requerido');

        } else if (linkUrl.trim() === '') {

            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo link es requerido');

        } else if (descripcion.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo descripcion es requerido');
        } else if (ratioGuaranies.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo ratio guaranies es requerido');

        } else if (ratioDolares.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo ratio dolares es requerido');

        } else if (ratioGuaraniesCheck.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo ratio guaranies check es requerido');

        } else if (ratioDolaresCheck.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo ratio dolares check es requerido');

        } else if (fechaInicioBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha inicio sorteo es requerido');

        } else if (dayjs(fechaInicioBackend).isAfter(dayjs(fechaHastaBackend))) {
            // Validar que la fecha de inicio no sea mayor que la fecha de fin
            setOpen(true);
            setSeverity('warning');
            setMensaje('La fecha de Hasta no puede ser menor a la fecha desde, en la vigencia del sorteo');
            return;

        } else if (fechaHastaBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha hasta sorteo es requerido');

        } else if (fechaInicioPublicacionBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha inicio publicacion es requerido');

        } else if (fechaHastaPublicacionBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha hasta publicacion es requerido');

        } else if (dayjs(fechaInicioPublicacionBackend).isAfter(dayjs(fechaHastaPublicacionBackend))) {
            // Validar que la fecha de inicio no sea mayor que la fecha de fin
            setOpen(true);
            setSeverity('warning');
            setMensaje('La fecha de Hasta no puede ser menor a la fecha desde, en la vigencia de publicacion');
            return;

        } else if (imagenFormData === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo imagen es requerido');

        } else if (imagenDetalleFormData === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo imagen detalle es requerido');
        } else {
            if (sorteoEspecial) {
                if (fechaInicioVigenciaFacturasBackend === '') {
                    setOpen(true);
                    setSeverity('warning');
                    setMensaje('El campo fecha inicio vigencia facturas es requerido');

                } else if (fechaHastaVigenciaFacturasBackend === '') {
                    setOpen(true);
                    setSeverity('warning');
                    setMensaje('El campo fecha hasta vigencia facturas es requerido');

                } else if (dayjs(fechaInicioVigenciaFacturasBackend).isAfter(dayjs(fechaHastaVigenciaFacturasBackend))) {
                    // Validar que la fecha de inicio no sea mayor que la fecha de fin
                    setOpen(true);
                    setSeverity('warning');
                    setMensaje('La fecha de Hasta no puede ser menor a la fecha desde, en la vigencia de facturas');
                    return;

                } else {
                    setLoadingGuardar(true);

                    handleUpdateSorteoApi(formData);
                }

            } else {

                setLoadingGuardar(true);

                handleUpdateSorteoApi(formData);
            }
        }
    };



    //=============================================api de actualizar sorteo
    const handleUpdateSorteoApi = (body) => {

        postUpdateSorteo(id, body, stateToken?.access_token)
            .then((response) => {
                console.log("response-postUpdateSorteo", response);
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');

                    setTimeout(() => {
                        navigate('/app/admin/sorteos');
                    }, 1500);

                }, 1000);


            })
            .catch((error) => {
                console.log("error-postUpdateSorteo", error);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar el sorteo');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };





    //=========================================================funcion para agregar imagen
    const handleAgregarImagen = (event) => {
        const file = event.target.files[0];
        console.log("file", file);

        if (file) {

            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    console.log("e.target.result", img.width, img.height);
                    if (img.width === 720 && img.height === 400) {
                        setImagen(e.target.result); // Establece la imagen si cumple con las dimensiones
                        setImagenFormData(file); // Establece el archivo para el FormData
                    } else {
                        setOpen(true); // Muestra un mensaje de error
                        setSeverity('error');
                        setMensaje('La imagen debe tener dimensiones 720x400 píxeles');
                    }
                };
                img.src = e.target.result; // Carga la imagen para verificar las dimensiones
            };
            reader.readAsDataURL(file);
        }

    };

    //=========================================================funcion para remover imagen
    const handleRemoverImagen = () => {
        setImagen('');
        setImagenFormData('');
    };

    //=========================================================funcion para remover imagen detalle
    const handleRemoverImagenDetalle = () => {
        setImagenDetalle('');
        setImagenDetalleFormData('');
    };

    //=========================================================funcion para agregar imagen detalle
    const handleAgregarImagenDetalle = (event) => {
        const file = event.target.files[0];
        console.log("file", file);

        if (file) {

            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    console.log("e.target.result", img.width, img.height);
                    if (img.width === 720 && img.height === 400) {
                        setImagenDetalle(e.target.result); // Establece la imagen si cumple con las dimensiones
                        setImagenDetalleFormData(file); // Establece el archivo para el FormData
                    } else {
                        setOpen(true); // Muestra un mensaje de error
                        setSeverity('error');
                        setMensaje('La imagen debe tener dimensiones 720x400 píxeles');
                    }
                };
                img.src = e.target.result; // Carga la imagen para verificar las dimensiones
            };
            reader.readAsDataURL(file);
        }

    };

    //=============================================funcion para seleccionar la fecha inicio vigencia sorteo
    const handleFechaInicio = (event) => {
        console.log("event", event);
        setFechaInicio(event);

        if (event) {
            // Formatear la fecha y hora en formato local (YYYY-MM-DD HH:mm:ss)
            let fecha = dayjs(event).format('YYYY/MM/DD HH:mm:ss');
            console.log("Fecha formateada:", fecha); // Ejemplo: 2025-04-17 11:25:00

            // Establecer la fecha en el backend
            setFechaInicioBackend(fecha);
        } else {
            console.error("El evento no contiene una fecha válida.");
        }
    };

    //=============================================funcion para seleccionar la fecha hasta vigencia sorteo 
    const handleFechaHasta = (event) => {
        // console.log("event", event);
        setFechaHasta(event);

        if (event) {
            // Formatear la fecha y hora en formato local (YYYY-MM-DD HH:mm:ss)
            let fecha = dayjs(event).format('YYYY/MM/DD HH:mm:ss');
            console.log("Fecha formateada:", fecha); // Ejemplo: 2025-04-17 11:25:00

            // Establecer la fecha en el backend
            setFechaHastaBackend(fecha);
        } else {
            console.error("El evento no contiene una fecha válida.");
        }

    };


    //=============================================funcion para seleccionar la fecha inicio publicacion
    const handleFechaInicioPublicacion = (event) => {
        // console.log("event", event);
        setFechaInicioPublicacion(event);


        if (event) {
            // Formatear la fecha y hora en formato local (YYYY-MM-DD HH:mm:ss)
            let fecha = dayjs(event).format('YYYY/MM/DD HH:mm:ss');
            console.log("Fecha formateada:", fecha); // Ejemplo: 2025-04-17 11:25:00

            // Establecer la fecha en el backend
            setFechaInicioPublicacionBackend(fecha);
        } else {
            console.error("El evento no contiene una fecha válida.");
        }
    };

    //=============================================funcion para seleccionar la fecha inicio publicacion
    const handleFechaHastaPublicacion = (event) => {
        // console.log("event", event);
        setFechaHastaPublicacion(event);

        if (event) {
            // Formatear la fecha y hora en formato local (YYYY-MM-DD HH:mm:ss)
            let fecha = dayjs(event).format('YYYY/MM/DD HH:mm:ss');
            console.log("Fecha formateada:", fecha); // Ejemplo: 2025-04-17 11:25:00

            // Establecer la fecha en el backend
            setFechaHastaPublicacionBackend(fecha);
        } else {
            console.error("El evento no contiene una fecha válida.");
        }
    };

    //=============================================funcion para seleccionar la fecha inicio vigencia facturas
    const handleFechaInicioVigenciaFacturas = (event) => {
        // console.log("event", event);
        setFechaInicioVigenciaFacturas(event);

        if (event) {
            // Formatear la fecha y hora en formato local (YYYY-MM-DD HH:mm:ss)
            let fecha = dayjs(event).format('YYYY/MM/DD HH:mm:ss');
            console.log("Fecha formateada:", fecha); // Ejemplo: 2025-04-17 11:25:00

            // Establecer la fecha en el backend
            setFechaInicioVigenciaFacturasBackend(fecha);
        } else {
            console.error("El evento no contiene una fecha válida.");
        }
    };

    //=============================================funcion para seleccionar la fecha fin vigencia facturas
    const handleFechaHastaVigenciaFacturas = (event) => {
        // console.log("event", event);
        setFechaHastaVigenciaFacturas(event);

        if (event) {
            // Formatear la fecha y hora en formato local (YYYY-MM-DD HH:mm:ss)
            let fecha = dayjs(event).format('YYYY/MM/DD HH:mm:ss');
            console.log("Fecha formateada:", fecha); // Ejemplo: 2025-04-17 11:25:00

            // Establecer la fecha en el backend
            setFechaHastaVigenciaFacturasBackend(fecha);
        } else {
            console.error("El evento no contiene una fecha válida.");
        }
    };


    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-7xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">
                            {id ? "Editar Sorteo" : "Nuevo Sorteo"}
                        </h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden p-6">
                            <AddSorteoComponents
                                id={id}
                                handleCancelar={handleCancelar}
                                handleGuardar={handleGuardar}
                                handleUpdateSorteo={handleUpdateSorteo}

                                titulo={titulo}
                                setTitulo={setTitulo}

                                linkUrl={linkUrl}
                                setLinkUrl={setLinkUrl}

                                imagen={imagen}
                                handleRemoverImagen={handleRemoverImagen}
                                handleAgregarImagen={handleAgregarImagen}

                                activoStatus={activoStatus}
                                setActivoStatus={setActivoStatus}

                                sorteoEspecial={sorteoEspecial}
                                setSorteoEspecial={setSorteoEspecial}

                                descripcion={descripcion}
                                setDescripcion={setDescripcion}

                                ratioGuaranies={ratioGuaranies}
                                setRatioGuaranies={setRatioGuaranies}

                                ratioDolares={ratioDolares}
                                setRatioDolares={setRatioDolares}

                                ratioGuaraniesCheck={ratioGuaraniesCheck}
                                setRatioGuaraniesCheck={setRatioGuaraniesCheck}

                                ratioDolaresCheck={ratioDolaresCheck}
                                setRatioDolaresCheck={setRatioDolaresCheck}

                                //fecha inicio sorteo
                                fechaInicio={fechaInicio}
                                handleFechaInicio={handleFechaInicio}

                                //fecha hasta sorteo
                                fechaHasta={fechaHasta}
                                handleFechaHasta={handleFechaHasta}

                                //fecha inicio publicacion
                                fechaInicioPublicacion={fechaInicioPublicacion}
                                handleFechaInicioPublicacion={handleFechaInicioPublicacion}

                                //fecha hasta publicacion
                                fechaHastaPublicacion={fechaHastaPublicacion}
                                handleFechaHastaPublicacion={handleFechaHastaPublicacion}

                                //fecha inicio vigencia facturas
                                fechaInicioVigenciaFacturas={fechaInicioVigenciaFacturas}
                                handleFechaInicioVigenciaFacturas={handleFechaInicioVigenciaFacturas}

                                //fecha hasta vigencia facturas
                                fechaHastaVigenciaFacturas={fechaHastaVigenciaFacturas}
                                handleFechaHastaVigenciaFacturas={handleFechaHastaVigenciaFacturas}

                                imagenDetalle={imagenDetalle}
                                handleRemoverImagenDetalle={handleRemoverImagenDetalle}
                                handleAgregarImagenDetalle={handleAgregarImagenDetalle}

                                loadingGuardar={loadingGuardar}
                            />
                        </div>
                    ) :
                        (
                            <div className="bg-white rounded-xl shadow-md p-8">
                                <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                                <div className="space-y-4">
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddSorteoPage;